module.exports = __webpack_public_path__ + "static/media/29ADMSPC11.7ac5adc8.jpg";